import { createSlice } from "@reduxjs/toolkit"


const initialState = {
    codeFilters: {},
    codeSorter: {},
    draftFilters: {}
}


const tableSlice = createSlice({
    name: 'table',
    initialState,
    reducers: {

        update: (state, action) => {

            let { key, value } = action.payload;
            state[key] = value
        }

    }
})

export const { update } = tableSlice.actions

export default tableSlice.reducer